module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=2.03"},{"quantity":0.03,"color":"#91E3AD","label":"2.03 - 2.64"},{"quantity":0.06,"color":"#DEFFB0","label":"2.64 - 3.29"},{"quantity":0.01,"color":"#FFE68C","label":"3.29 - 4.55"},{"quantity":9,"color":"#FF9982","label":"4.55 - 6.44"},{"quantity":12,"color":"#FF4D30","label":"6.44 - 13.32"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_100_rice.json
// module id = axPh
// module chunks = 171